import { z } from 'zod';

import { zodFilterConfigSchema } from '~/data/deliveryNote/zodDeliveryNoteFiltersSchema';

import { dataExportJobCreatedSchema } from '../validations';

import { DELIVERY_NOTE_PDF_EXPORT_FORMATS } from './constants';

/**
 * Selection of a delivery note PDF export.
 */
export const zodCreateDeliveryNotePdfExportPayloadSchema = z.object({
  assetIds: z.array(z.uuid()).nullish(),
  filterConfig: zodFilterConfigSchema.nullish(),
  format: z.enum(DELIVERY_NOTE_PDF_EXPORT_FORMATS),
});

export const zodCreateDeliveryNotePdfExportResponseSchema =
  dataExportJobCreatedSchema;
